interface DocumentTypeProps {
    docType?: string;
}

const DocumentType = (props: DocumentTypeProps) => {
    if(!props.docType){
        return '';
    }
    if(props.docType.toLowerCase() === 'advanceshipmentnotice'){
        return 'Shipment';
    }
    if(props.docType.toLowerCase() === 'poack'){
        return 'Acknowledgement';
    }
    return props.docType;
};

export default DocumentType;
